import clsx from 'clsx';
import React from 'react';

import { PrimaryButton, TextButton } from '@components/Button/variants';

interface StepContainerProps {
  children: React.ReactNode;
  continueButtonType?: 'button' | 'submit';
  disableContinue?: boolean;
  error?: string;
  heading: string;
  hideSkip?: boolean;
  nextStep: () => void;
  onContinue?: () => void;
  subheading: string;
}

type StepControlsProps = Omit<StepContainerProps, 'children' | 'heading' | 'subheading'>;

const StepControls = ({
  nextStep,
  onContinue,
  disableContinue,
  hideSkip,
  error,
}: StepControlsProps) => {
  return (
    <div className={clsx('onboarding-footer', { '!pb-24': hideSkip })}>
      {error && <div className="onboarding-error mb2">{error}</div>}
      <PrimaryButton
        as="button"
        size="small"
        fullWidth
        onClick={onContinue || nextStep}
        disabled={disableContinue}
      >
        Continue
      </PrimaryButton>
      {!hideSkip && (
        <TextButton as="button" size="small" fullWidth onClick={nextStep}>
          Skip
        </TextButton>
      )}
    </div>
  );
};

const StepContainer = ({
  heading,
  subheading,
  nextStep,
  onContinue,
  disableContinue,
  continueButtonType,
  hideSkip,
  children,
  error,
}: StepContainerProps) => (
  <>
    <div className="onboarding-content">
      <h2 className="onboarding-heading">{heading}</h2>
      <p className="mt2">{subheading}</p>
      {children}
    </div>
    <StepControls
      nextStep={nextStep}
      onContinue={onContinue}
      disableContinue={disableContinue}
      continueButtonType={continueButtonType}
      hideSkip={hideSkip}
      error={error}
    />
  </>
);

export default StepContainer;
